import { UseQueryResult, useQuery } from 'react-query'
import { request } from '../request'

export const useGetTransactionTypes = (): UseQueryResult<
  Array<{ id: number; name: string }>,
  Error
> => {
  return useQuery(['transaction-types'], () =>
    request<Array<{ id: number; name: string }>>({
      url: '/utils/transaction-types',
      method: 'GET',
    }),
  )
}
